const stickyNav = ({
  selector = '.sticky',
  appliedClass = 'stick',
  micrositeStickyScrollThreshold,
  micrositeNavBar,
  scrollThreshold,
}) => {
  const nav = document.querySelector(selector);

  const top = () => {
    if (window.pageYOffset !== undefined) {
      return window.pageYOffset;
    }

    return (document.documentElement
      || document.body.parentNode
      || document.body)
      .scrollTop;
  };

  const updateStickyNavUI = (tp, threshold, el) => {
    if (tp >= threshold) {
      el.classList.add(appliedClass);
      if (micrositeNavBar && window.screen.width > 768) {
        nav.style.setProperty('top', `${micrositeStickyScrollThreshold}px`);
      }
      // Workaround to adjust footer padding for ipad and mobile
      let offset = 0;
      if (micrositeNavBar && window.screen.width <= 768 && window.screen.height <= 1024) {
        offset = `${el.offsetHeight}px`;
      }
      const footer = document.querySelector('.main-footer');
      footer.style.setProperty('padding-bottom', offset);
    } else {
      el.classList.remove(appliedClass);
    }
  };

  const scrollHandler = () => {
    const scrollTop = top();

    updateStickyNavUI(scrollTop, scrollThreshold, nav);
  };

  const scrollTop = top();

  updateStickyNavUI(scrollTop, scrollThreshold, nav);

  window.addEventListener('scroll', scrollHandler);
};

export default stickyNav;
